import { style } from '@vanilla-extract/css';

const fontFamily = "'Roboto', Times, sans-serif";

export const wrapper = style({
  fontFamily,
  zIndex: 2,
  width: '100%',
  minHeight: '100vh',
  backgroundColor: 'transparent',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '1rem',
});

export const card = style({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '1rem',
});

export const image = style({
  width: 300,
  imageRendering: 'auto',
});

export const message = style({
  fontFamily,
  fontSize: '0.875rem',
});
